import { render, staticRenderFns } from "./RecipePatient.vue?vue&type=template&id=a24fa810&scoped=true"
import script from "./RecipePatient.vue?vue&type=script&lang=js"
export * from "./RecipePatient.vue?vue&type=script&lang=js"
import style0 from "./RecipePatient.vue?vue&type=style&index=0&id=a24fa810&prod&lang=scss&scoped=true"
import style1 from "./RecipePatient.vue?vue&type=style&index=1&id=a24fa810&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24fa810",
  null
  
)

export default component.exports